import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CreateZone from '@/pages/create-zone/CreateZone.vue';

export default {
  path: '/create-zone',
  name: 'CreateZone',
  components: {
    mainContent: CreateZone,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'create-zone',
    },
    breadcrumb: {
      title: 'Cadastro de Zona',
      paths: [{ title: 'Cadastro' }, { title: 'Zona' }],
    },
  },
};
